export * from './featuredCards.variants.defaults';
